import { useEffect, useState } from "react";

/**
 * Returns `value` after it has been stable for `delayMs` milliseconds.
 * Useful for debouncing API calls from text inputs without re-firing on every keystroke.
 */
export default function useDebouncedValue(value, delayMs = 300) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(id);
    }, [value, delayMs]);
    return debounced;
}
